(function() {
    angular.module('ngmvac').controller('menuController', MenuController);
    MenuController.$inject = ['$scope', '$window', '$filter', '$timeout','timeService', 'HotelFactory', '$location'];

    function MenuController($scope, $window, $filter, $timeout, timeService, HotelFactory, $location) {
        var vm = this;
        vm.activeCurrency = '';
        vm.currencies = [];
        vm.currenciesVisible = false;

        if($window.location.pathname == '/' || $window.location.pathname == '/hotel' || /details/i.test($location.absUrl())){
            // HotelFactory.getCurrencies().then(function(response){
            //     vm.activeCurrency   = response.data.active;
            //     vm.currencies       = response.data.currencies;
            //     vm.currenciesVisible = true;
            // });
        }

        vm.setCurrency = function(currency){
            HotelFactory.setCurrency(currency).then(function(response){
                vm.activeCurrency = currency;
                if($window.location.pathname == '/hotel' || /details/i.test($location.absUrl()))
                    $window.location.reload();
            });
        }
        
    }
})();